// extracted by mini-css-extract-plugin
export default {"LoadingMessage":"EclipseLoader_LoadingMessage__NVcSC","LoadingPage":"EclipseLoader_LoadingPage__WnexG","Loader":"EclipseLoader_Loader__TKF6I","spin":"EclipseLoader_spin__r+Vie"};